module.exports = "/_next/static/images/fa1c0dd9967cb7691b64b3f08c2b0145-credit-card-prepayment@3x.png";